/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
  Button
} from '@material-ui/core'
import { PropagateLoader } from 'react-spinners'
import Header from 'component/header'
import CloseIcon from '@material-ui/icons/Close'
import { map, isEmpty } from 'ramda'
import Bottom from 'component/bottom'
import { useTranslation } from 'react-i18next'
import store from 'store'
import http from 'service/http'
import useLoading from '../loading/hook'
import styles from './style'
import SLOTS from './constant'
import config from 'config'
import queryString from 'query-string'
import Head from '../../component/layout/Head'
import Testimonials from '../../component/layout/Testimonials'
import TotalPlay from '../../component/layout/TotalPlay'


const listFishing = [
  {
    image: './images/home/gamessg.png',
    class: 'pages-icon-hot'
  },
  {
    image: './images/home/gamesjoker.png',
    class: 'pages-icon-hot'
  },
  {
    image: './images/home/gamesjdb.png',
    class: 'pages-icon-hot'
  },
  {
    image: './images/home/gamesfungaming.png',
    class: 'pages-icon-hot'
  },
  {
    image: './images/home/gamesfachai.png',
    class: 'pages-icon-hot'
  },
  {
    image: './images/home/gamesbg.png',
    class: 'pages-icon-hot'
  },
  {
    image: './images/home/gamesxiyou.png',
    class: 'pages-icon-hot'
  }
]
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const generateDeeplink = ({ id, account, password }) => {
  const proxy = {
    3: `lobbyplay8oy://lobbyplay8oy?account=${account}&password=${password}`,
    11: '',
    2: '',
    1: ''
  }

  return proxy[id]
}

function home({ history, classes }) {
  const [loading, withLoading] = useLoading(false)
  const [gameSelected, updateGameSelected] = React.useState({})
  const [games, setGames] = React.useState([])
  const { location: { search } } = history
  const { game } = queryString.parse(search)
  const { user_id: userId } = store.get('user') || { user_id: undefined }
  const image = './images/home/fishingbanner.png'


  const gamesSetup = async () => {
    const gameList = await http.get({ path: 'games' })
    setGames(gameList)
    return gameList
  }

  const loginToGame = async ({ src, label, route, id, redirect, target, deeplink }, gameList = null) => {

    if (target === '_blank') {
      window.open(route)
    }
    if (redirect) {
      history.push(route)
      return
    }
    if (!gameList && (id === null || !games.find(({ id: gameId }) => id === gameId))) {
      updateGameSelected({ label, src, err: 'System Maintenance ' })
      return
    }
    if (gameList && (id === null || !gameList.find(({ id: gameId }) => id === gameId))) {
      updateGameSelected({ label, src, err: 'System Maintenance ' })
      return
    }
    updateGameSelected({ label, src, route, id })
    const { balance, account, err, game_password: password } = await withLoading(() =>
      http.post({
        path: `users/${userId}/game/logout`, payload: {
          gameLoginId: id
        }
      })
        .catch(error => {
          if (error.message !== 'Not enough money !') {
            // eslint-disable-next-line no-throw-literal
            throw { message: error.message }
          }
          return true
        })
        // .then(() => deeplink || [10, 2, 14].includes(id) ? true : http.get({ path: `games/${id}/login` }))
        .then(() => http.get({ path: `users/${userId}/games/${id}/balance` })))
      .catch((error) => {
        return { err: error.message }
      })

    const outDeeplink = generateDeeplink({ id, account, password })

    updateGameSelected({ label, src, route, id, balance: balance.balance,  account: balance.account, err, deeplink: outDeeplink, password })
    if(!outDeeplink && outDeeplink !== '') history.push(route)
  }

  React.useEffect(() => {
    if (userId) {
      http.post({ path: `users/${userId}/sync-game` })
    }
    async function fetchGame() {
      const gameList = await gamesSetup()
      // console.log(gameList)
      if(game) {
        const { src, label, route, id, redirect, target, deeplink } = SLOTS.find(x => x.code === game)
        loginToGame({ src, label, route, id, redirect, target, deeplink }, gameList)
      }
    }
    fetchGame()

  }, [])
  window.mobilecheck = () => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
  const handleClose = () => {
    updateGameSelected({})
  }
  const { t } = useTranslation()

  return (
    <div style={{ display: 'flex', flexDirection: 'column', background: "#fff" }}>
      <Head image={image} alt="bannerfishing" />
      <div className="pages">
        <button className="pages-btn-items">Fishing</button>
        <div className="pages-card">
          {listFishing.map(i => (
            <div className="pages-item">
              <img src={i.image} alt={i.image} />
              <div className={i.class}>
                {i.class !== '' && (
                  <>{i.class === 'pages-icon-hot' ? 'HOT' : 'Comming Soon'}</>
                )}
              </div>
            </div>
          ))}
        </div>
        <img
          style={{ width: '100%', margin: '30px 0' }}
          src="./images/home/bannerfishingplay.png"
          alt="bannerfishing"
        />
        <TotalPlay />
        <Testimonials />
      </div>
      <div className="col8">
        <div className="ml-2 mr-2">
          <div className="title_recoment tile_deposit">{t('FISHING')}</div>
          <div className="row">
            {!window.mobilecheck()
              ? map(
                  ({
                    src,
                    label,
                    route,
                    id,
                    redirect,
                    target,
                    deeplink,
                    idrActive
                  }) =>
                    config.currency == 'IDR' && idrActive == 0 ? (
                      ''
                    ) : (
                      <div
                        key={label}
                        className="col-4 col-sm-3 mb-4"
                        cols={2.5}
                        onClick={() =>
                          loginToGame({
                            src,
                            label,
                            route,
                            id,
                            redirect,
                            target,
                            deeplink
                          })
                        }
                      >
                        <img
                          style={{
                            width: '100%',
                            borderRadius: 10,
                            boxShadow: '0px 0px 8px #C09981',
                            cursor: 'pointer'
                          }}
                          src={src}
                          alt="97ipay"
                        />
                      </div>
                    ),
                  SLOTS
                )
              : map(
                  ({
                    src,
                    label,
                    route,
                    id,
                    redirect,
                    target,
                    deeplink,
                    idrActive
                  }) =>
                    config.currency == 'IDR' && idrActive == 0 ? (
                      ''
                    ) : (
                      <div
                        key={label}
                        className="col-4 col-sm-3 mb-4"
                        cols={2.5}
                        onClick={() =>
                          loginToGame({
                            src,
                            label,
                            route,
                            id,
                            redirect,
                            target,
                            deeplink
                          })
                        }
                      >
                        <img
                          style={{
                            width: '100%',
                            borderRadius: 10,
                            boxShadow: '0px 0px 8px #C09981',
                            cursor: 'pointer'
                          }}
                          src={src}
                          alt="97ipay"
                        />
                      </div>
                    ),
                  SLOTS.filter(x => x.code !== 'playtech')
                )}
          </div>
        </div>
        <Dialog
          fullScreen
          open={!isEmpty(gameSelected)}
          onClose={handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                {gameSelected.label}
              </Typography>
            </Toolbar>
          </AppBar>
          <div
            style={{
              background: '#23232A',
              padding: 25,
              marginTop: 70,
              height: 'calc(100vh - 70px)',
              overflow: 'auto'
            }}
          >
            <Card
              style={{
                background: 'none',
                border: '1px solid #ffaf50',
                borderRadius: '16px',
                maxWidth: '400px',
                margin: '0 auto'
              }}
            >
              <CardActionArea>
                <CardMedia
                  component="img"
                  alt="Contemplative Reptile"
                  className={classes.media}
                  image={gameSelected.src}
                  title="Contemplative Reptile"
                />
                <CardContent style={{ textAlign: 'center' }}>
                  {gameSelected.err ? (
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="h2"
                      style={{ fontWeight: 'bold', color: '#ffaf50' }}
                    >
                      {gameSelected.err}
                    </Typography>
                  ) : loading ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        margin: 15
                      }}
                    >
                      <PropagateLoader
                        sizeUnit="px"
                        size={20}
                        color="#f50057"
                        loading={loading}
                      />
                    </div>
                  ) : (
                    <React.Fragment>
                      <Typography
                        gutterBottom
                        variant="h5"
                        component="h2"
                        style={{ fontWeight: 'bold', color: '#ffaf50' }}
                      >
                        Account: {gameSelected.account}
                      </Typography>
                      {gameSelected.password ? (
                        <Typography
                          gutterBottom
                          variant="h5"
                          component="h2"
                          style={{ fontWeight: 'bold', color: '#ffaf50' }}
                        >
                          Password: {gameSelected.password}
                        </Typography>
                      ) : null}
                      <Typography
                        gutterBottom
                        variant="h5"
                        component="h2"
                        style={{ fontWeight: 'bold', color: '#ffaf50' }}
                      >
                        Balance: {gameSelected.balance}
                      </Typography>
                      {gameSelected.deeplink !== undefined ? (
                        <a
                          className="link-btn-default"
                          href={gameSelected.deeplink}
                        >
                          Play now
                        </a>
                      ) : (
                        <Button
                          onClick={() => history.push(gameSelected.route)}
                          fullWidth
                          variant="contained"
                          color="primary"
                          className={classes.submit}
                        >
                          <strong>Play now</strong>
                        </Button>
                      )}
                    </React.Fragment>
                  )}
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
        </Dialog>
      </div>
    </div>
  )
}
export default withStyles(styles)(home)
